import React from 'react';
import { classNames, layoutClassNames } from './classNames';
import type { LayoutClassNameProps } from './classNames';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>, LayoutClassNameProps {
  id: string;
  label: React.ReactNode;
  inline?: boolean;
  wrapperClassName?: string;
  labelClassName?: string;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(({
  id,
  label,
  inline = false,
  wrapperClassName,
  labelClassName,
  className,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  ...props
}, ref) => (
  <div
    className={classNames(
      'form-check',
      inline ? 'form-check-inline' : undefined,
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      wrapperClassName,
    )}
  >
    <input
      ref={ref}
      id={id}
      type="checkbox"
      className={classNames('form-check-input', className)}
      {...props}
    />
    <label className={classNames('form-check-label', labelClassName)} htmlFor={id}>
      {label}
    </label>
  </div>
));

Checkbox.displayName = 'Checkbox';

export default Checkbox;
